export default "__VITE_ASSET__B$WAQGVA__"